<script>
import { Line } from "vue-chartjs";
import { CustomTooltips } from "@coreui/coreui-plugin-chartjs-custom-tooltips";
import { hexToRgba } from "@coreui/coreui-pro/dist/js/coreui-utilities";

export default {
  components: {
    hexToRgba,
    CustomTooltips
  },
  props: {
    type: { type: String, default: "" },
    years: { type: Array, default: [] },
    revisions: { type: Array, default: [] }
  },
  extends: Line,
  methods: {
    renderLinePrepare: function() {
      this.$refs.canvas.id = "line-chart-" + this.type;

      this.min = 100000;
      this.max = 0;

      for (var i = 0; i < this.years.length; i++) {
        var n = Number(this.years[i]);

        if (!isNaN(n) && n > 0) {
          this.max = Math.max(this.max, n);
          this.min = Math.min(this.min, n);
        }
      }

      if (this.max == 0) {
        for (var i = 0; i < this.revisions.length; i++) {
          var n = Number(this.revisions[i]);
          if (!isNaN(n) && n > 0) {
            this.max = Math.max(this.max, n);
            this.min = Math.min(this.min, n);
          }
        }
      }

      this.max = this.max + this.max * 0.05;
      this.min = this.min - this.min * 0.05;

      this.max = Math.ceil(this.max / 100) * 100;
      this.min = Math.floor(this.min / 100) * 100;

      if (this.min > this.max) {
        this.min = 0;
        this.max = 100;
      }
      this.min = 0;
    },
    renderLineChart: function() {
      this.renderChart(
        {
          labels: ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
          datasets: [
            {
              label: this.type,
              fill: false,
              backgroundColor: "#217143",
              borderColor: "#217143",
              data: this.years,
              borderWidth: 1
            },
            {
              label: "Revisions",
              fill: false,
              backgroundColor: "#FF6600",
              borderColor: "#FF6600",
              borderDash: [5, 5],
              data: this.revisions,
              borderWidth: 1
            }
          ]
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: false,
                  min: this.min,
                  max: this.max
                }
              }
            ]
          },
          legend: {
            display: false
          },
          tooltips: {
            enabled: false,
            custom: CustomTooltips,
            intersect: true,
            mode: "index",
            position: "nearest",
            callbacks: {
              labelColor: function(tooltipItem, chart) {
                return {
                  backgroundColor:
                    chart.data.datasets[tooltipItem.datasetIndex]
                      .backgroundColor
                };
              }
            }
          }
        }
      );
    }
  },
  data: function() {
    return {
      min: 0,
      max: 0
    };
  },
  mounted() {
    this.renderLinePrepare();
    this.renderLineChart();
  },
  watch: {
    type: function() {
      // this._chart.destroy();
      this.renderLineChart();
    },
    years: function() {
      this.renderLinePrepare();
      this.renderLineChart();
    }
  }
};
</script>
